import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppSettings } from "../appsettings/appsettings";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { MessageCenter } from "../_models/news-article.model";

@Injectable({
  providedIn: "root",
})
export class MessageCenterService {
  private apiUrl = `${AppSettings.API_ENDPOINT}/api/UpdateNotifications`;

  constructor(
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService,
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders()
      .append("Content-Type", "application/json; charset=UTF-8")
      .append("Authorization", "Bearer " + this.oidcSecurityService.getAccessToken());
  }

  getMessages(isPortal?: boolean): Observable<MessageCenter[]> {
    return this.http
      .get<MessageCenter[]>(`${this.apiUrl}/isPortal?isPortal=${isPortal}`, {
        headers: this.getHeaders(),
      })
      .pipe(
        map((messages) =>
          messages.sort((a, b) => {
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
          }),
        ),
      );
  }

  getMessage(id: number): Observable<MessageCenter> {
    return this.http.get<MessageCenter>(`${this.apiUrl}/${id}`, {
      headers: this.getHeaders(),
    });
  }

  createMessage(message: MessageCenter): Observable<MessageCenter> {
    return this.http.post<MessageCenter>(`${this.apiUrl}`, message, {
      headers: this.getHeaders(),
    });
  }

  updateMessage(id: number, message: MessageCenter): Observable<MessageCenter> {
    return this.http.put<MessageCenter>(`${this.apiUrl}/${id}`, message, {
      headers: this.getHeaders(),
    });
  }

  deleteMessage(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`, {
      headers: this.getHeaders(),
    });
  }
}
